import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-bordered-section',
  template: '<ng-content></ng-content>',
})
export class BorderedSectionComponent {
  @HostBinding('class')
  private classes = 'block border border-dashed border-navy-70 rounded-md p-4 bg-navy-10 p-5';
}
